import React from 'react';

const PointIcon = () => {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M15.1033 6.98326C15.4701 6.24009 16.5299 6.24009 16.8967 6.98326L19.3475 11.9483L24.8296 12.7496C25.6495 12.8694 25.9763 13.8773 25.3827 14.4554L21.4167 18.3183L22.3524 23.7743C22.4926 24.5912 21.635 25.2142 20.9014 24.8284L16 22.2508L11.0987 24.8284C10.365 25.2142 9.50747 24.5912 9.64759 23.7743L10.5834 18.3183L6.61736 14.4554C6.02377 13.8773 6.35056 12.8694 7.17047 12.7496L12.6525 11.9483L15.1033 6.98326Z'
        stroke='#3F4756'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default PointIcon;
